/*
 * File: StoryContent.styles.js
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on May 19, 2025 at 1:18 PM
 * Copyright © 2025 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: May 26, 2025 at 2:52 PM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import styled from 'styled-components';


/**
 * Styles
 */

export const StoryContainer = styled.div`
	user-select: none;
	white-space: pre-wrap;
	display: flex;
	flex-direction: column;
	gap: 20px;

	p {
		line-height: 180%;
	}
`;

export const TriggerWarning = styled.div`
	background-color: ${({ theme }) => theme.statusWarningLighter};
	border: 1px solid ${({ theme }) => theme.statusWarningBase};
	padding: 5px 9px 5px 9px;
    border-radius: 8px;

	p {
		color: ${({ theme }) => theme.statusWarningBase};
	}
`;

export const MediaContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	margin: 8px 0px 16px;
	position: relative;
	overflow: hidden;
	border-radius: 8px;

	&.trigger {
		img {
			-webkit-filter: blur(10px);
			-moz-filter: blur(10px);
			-o-filter: blur(10px);
			-ms-filter: blur(10px);
			filter: blur(10px);
		}
	}
`;

export const TriggerToggleContainer = styled.div`
	width: 100%;
	height: 100%;
	background-color: transparent;
	position: absolute;
	z-index: 2;
	display: flex;
	justify-content: center;
	align-items: center;
`;

export const LightenOverlay = styled.div`
	width: 100%;
	height: 100%;
	position: absolute;
	background-color: ${({ theme }) => theme.white};
	opacity: 0.5;
`;

export const Overlay = styled.div`
	width: 100%;
	height: 100%;
	background-color: transparent;
	position: absolute;
	border-radius: 5px;
	z-index: 1;
`;

export const MediaImage = styled.img`
	border-radius: 5px;
	max-width: 100%;
	max-height: 650px;
	-webkit-transition: -webkit-filter 100ms linear;
	-moz-transition: -moz-filter 100ms linear;
	-o-transition: -o-filter 100ms linear;
	-ms-transition: -ms-filter 100ms linear;
	transition: filter 100ms linear;
`;

export const ContentSection = styled.div``;

export const MessageCard = styled.div`
	background-color: ${({ theme }) => theme.neutralButton};
	padding: 18px;
	border-radius: 8px;

	h5 {
		margin: 0px 0px 8px;
	}
`;

export const ArtworkArtist = styled.span`
	color: ${({ theme }) => theme.secondaryText};
	font-size: 0.8rem;
	margin-top: -26px;
	width: 100%;
	text-align: center;
	display: block;
`;
